import React from "react";
import GrowLogo from "../assets/images/grow-logo.svg";
import Container from "./Container";
import LanguageSelector from "./LanguageSelector";
import { Link } from 'react-router-dom'

const Header = () => {
  return (
    <div className="">
      <div className={`bg-home-banner bg-no-repeat relative `}>
      {" "}
        <Container >
          <div className="relative z-1 ">
            <div className="flex  py-[20px] lg:justify-start justify-between">
              <div>
                   <Link to="/">
                <img src={GrowLogo} alt="Grow-Logo" className='sm:h-[50px]  h-[39px]' />  </Link>
              </div>
            </div>
            
          <LanguageSelector/>
          </div>
        </Container> 
      </div>
    </div>
  );
};

export default Header;
